import Head from 'next/head'
import styles from "../styles/Pages/Home.module.scss"
import Topbanner from '../components/Reusable/Banner/Topbanner'
import Link from 'next/link'

export default function TermsandCondition() {
    return (
        <>
            <Head>
                <title>Adventure Resorts Cancellation and Reschedule Policy</title>
                <meta name="description" content="Managing your travel plans is made easier with our Cancellation and Reschedule Policy. Familiarize yourself with our policy to ensure a seamless experience." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.adventureresortkufri.com/cancellation-and-refundpolicies" />
            </Head>
            <Topbanner bgImage={"/images/cancellation-banner.png"} title={"Cancellation And Refund Policy"} target="#firstsec"/>
            <section className={`${styles.privacy_policy} common_padding`} id="firstsec">
                <div className='container'>
                    <div className='common_title'>
                        <h2>Adventure Resorts Cancellation and Reschedule Policy:</h2>
                        <p>Cancellations or modifications must be done 7 days before Check-in.</p>

                        <h2>Park Cancellation and Reschedule Policy:</h2>
                        <h3>Modification Policy:</h3>
                        <ul>
                            <li>There will be no charges for modification, however, any change in ticket rate on
                                account of park location change or weekday to weekend change or category
                                change, a difference amount will be charged. Conversely, there will be no refund
                                of the difference amount</li>
                            <li>You can modify your bookings before 12 AM, one day prior to the original
                                booking date. You will have a validity of 90 days for postponing.</li>
                            <li>Note: Modification of your tickets will be allowed free of charge only once per
                                booking.</li>
                            <li>Cancellation will not be allowed on modifies bookings.</li>
                        </ul>
                        <h3>Partial and Full Cancellation Policy:</h3>
                        <ul>
                            <li>If you wish to cancel your booking before 7 days of visit, 100% of the original
                                amount will be refunded.</li>
                            <li>If you wish to cancel your booking within 7 days of visit, 85% of the original
                                amount will be refunded.</li>
                            <li>Above rates will also be applicable for partial cancellation.</li>
                            <li>There will be no refund in the case of no show on the day of visit or after the date
                                of visit.</li>
                        </ul>


                        <h2>Cancellation Policy </h2>
                        <p>Cancellation before 03days no retention and less then 03 days full retention charges, No refund last day cancellation or no-show</p>
                        <p><strong>Note:-</strong> As per the Government directives it is Mandatory for all the guest (Foreign Nationals, NRI’s and Indian Nationals) to show their Photo ID proof at the time of Check-In which can be in form of ‘Passport and Visa Copy, Driving License, PAN Card , Voter ID Card , failing which the hotel reserves the right of refusal…</p>
                        <p>In case of any assistance, please feel free to <Link href="/contact-us" ><strong>contact</strong></Link> with us.</p>
                    </div>
                </div>
            </section>
        </>
    )
}
